module.exports = __webpack_public_path__ + "static/media/course-default.c248838a.png";